/* eslint-disable */

<template>
  <div>
    <vue-sortable :options="options" @drag:start="startedDrag" @drag:stop="stoppedDrag" @sortable:sort="sort">
      <div class="vx-row" :class="{ 'cursor-drag': draggingCard === true }">
        <div class="vx-col lg:w-3/12 md:w-3/12 sm:w-5/5">
          <vx-card class="mb-base">
            <h3 class="font-bold mb-4">Controls</h3>
            <vue-draggable-container id="wordBank" class="wordBank gap-4">
              <h5 class="dragBlock font-semibold cursor-pointer">False</h5>
              <h5 class="dragBlock font-semibold cursor-pointer">1000</h5>
              <h5 class="dragBlock font-semibold cursor-pointer">''''</h5>
              <h5 class="dragBlock font-semibold cursor-pointer">0.1</h5>
              <h5 class="dragBlock font-semibold cursor-pointer">1.602176634E-19</h5>
            </vue-draggable-container>
          </vx-card>
        </div>
        <div class="vx-col lg:w-9/12 md:w-9/12 sm:w-5/5">
          <div class="grid grid-cols-4 gap-4">
            <vx-card class="mb-base">
              <p class="text-xl font-semibold mb-3">STRING</p>
              <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="input0" />
            </vx-card>
            <vx-card class="mb-base">
              <p class="text-xl font-semibold mb-3">BOOLEAN</p>
              <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="input1" />
            </vx-card>
            <vx-card class="mb-base">
              <p class="text-xl font-semibold mb-3">INTEGER</p>
              <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="input2" />
            </vx-card>
            <vx-card class="mb-base">
              <p class="text-xl font-semibold mb-3">FLOAT</p>
              <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="input3" />
            </vx-card>
          </div>
        </div>
      </div>
    </vue-sortable>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import Prism from 'vue-prism-component';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      draggingCard: false,
      //last_drag_error: false,

      options: {
        draggable: '.dragBlock',
        dropzone: '.dropzoneStandard',
      },
    };
  },
  methods: {
    startedDrag(x) {
      x.data.source.className += ' currently-dragging-standard';
      this.draggingCard = true;
    },
    stoppedDrag() {
      this.draggingCard = false;
    },
    sort(x) {
      const overContainer = x.data.dragEvent.data.overContainer;
      const sourceContainer = x.data.dragEvent.data.sourceContainer;
      if (overContainer && overContainer.id !== 'wordBank' && overContainer.children) {
        if (overContainer.children.length > 0 && overContainer.id !== sourceContainer.id) {
          //this.drag_error()
          x.cancel();
        }
      }
    },
    markSimulation() {
      let totalScore = 0;

      if (document.getElementById('input0').textContent === "''''") {
        document.getElementById('input0').style.borderColor = '#28C76F';
        totalScore++;
      }
      if (document.getElementById('input1').textContent === 'False') {
        document.getElementById('input1').style.borderColor = '#28C76F';
        totalScore++;
      }
      if (document.getElementById('input2').textContent === '1000') {
        document.getElementById('input2').style.borderColor = '#28C76F';
        totalScore++;
      }
      if (document.getElementById('input3').textContent === '0.1') {
        document.getElementById('input3').style.borderColor = '#28C76F';
        totalScore++;
      }

      if (totalScore === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', totalScore);
      }

      return this.$emit('simulation_getting_there', totalScore);
    },
  },
  components: {
    draggable,
    Prism,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
